export const getPrefixTransformStyleString = (value: string, returnAs: 'string' | 'object' = 'string') => {
  if (returnAs === 'string')
    return `
      -webkit-transform: ${value}; 
      -moz-transform: ${value}; 
      -ms-transform: ${value}; 
      -o-transform: ${value}; 
      transform: ${value};
    `;
  else if (returnAs === 'object')
    return {
      '-webkit-transform': value,
      '-moz-transform': value,
      '-ms-transform': value,
      '-o-transform': value,
      transform: value,
    };
};
